export default "__VITE_ASSET__Ebr5M2Th__"